import type { FaireProductEntity } from "../../entity_types/product";

export const p_1k91llzd5y: FaireProductEntity = {
  token: "p_1k91llzd5y",
  type: "product",
  name: "BABY DECONGESTANT SALVE | 2 oz",
  brandToken: "b_5dagse75md",
  brandName: "Rowe Casa Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/7000a486b408c430a962ab3fedcbc7b22d34752e6be9bed87b6205f258c80624.png",
  galleryImageUrls: [],
  priceDollars: 16.8,
  description:
    'Stuffy nose? Congestion? The inability to breathe freely is frustrating and exhausting for everyone. Eucalyptus, myrtle and thyme are the superstars in this salve that help open your airways and clear sinus passages.\n\nTO USE: Apply around nose and gently massage on baby’s feet and chest as needed for relief.\n\nINGREDIENTS: RAW SHEA BUTTER, ORGANIC RAW UNREFINED COLD PRESSED COCONUT OIL, ORGANIC BEESWAX, 100% PURE THERAPEUTIC GRADE ESSENTIAL OILS: MYRTLE, EUCALYPTUS RADIATA, TEA TREE, LAVENDER, LEMON, FRANKINCENSE, ROMAN CHAMOMILE.\n\n*Always check with your doctor before using a new product or supplement if you have any questions or concerns about how a product may affect your current health, medications, pregnancy, or breastfeeding.\n\nDimension: 2 oz, 2.145" x 1.89" x 2.145"\n',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:25:49.099Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
